import { createSlice } from '@reduxjs/toolkit';

export const briefIdSplice = createSlice({
  name: 'briefId',
  initialState: {
    briefId: null
  },
  reducers: {
    setBriefId: (state, action) => {
      state.briefId = action.payload;
    }
  }
});



export const { setBriefId } = briefIdSplice.actions;
